import { render, staticRenderFns } from "./hallways.vue?vue&type=template&id=6fe840b1&"
import script from "./hallways.vue?vue&type=script&lang=ts&"
export * from "./hallways.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports